import { mapMutations } from 'vuex'
import pThrottle from 'p-throttle'
import pForever from 'p-forever'

const plugin = {
  install(Vue) {
    Vue.mixin({
      data: () => ({ destroyed: false }),

      beforeDestroy() {
        this.destroyed = true
      },

      methods: {
        ...mapMutations(['incrementPendingTasks', 'decrementPendingTasks']),

        withModalLoading(arg, interval = 60000) {
          const throttledFunction = pThrottle(
            () => (this.destroyed ? pForever.end : arg()),
            1,
            interval
          )

          this.incrementPendingTasks()
          return typeof arg === 'function'
            ? throttledFunction().finally(() => {
                this.decrementPendingTasks()
                pForever(throttledFunction)
              })
            : arg.finally(() => this.decrementPendingTasks())
        }
      }
    })
  }
}

export default plugin
